"use strict";

angular.module("core")
.service("DepartmentService", function($resource, appConfig) {
    var resource = $resource(appConfig.API_SERVER + "/auth/departments/", {}, {
        query: {
            method: "get",
            isArray: true,
            ignoreLoadingBar: true
        }
    });

    this.query = function() {
        return resource.query();
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/department-selector/department.service.js
// module id = 429
// module chunks = 0